class ProfessionalAlert {
  constructor() {
    this.root = document.querySelector('.professional-alert');
    if (!this.root) return;

    this.modal = this.root.querySelector('.professional-alert__modal');
    this.closeBtn = this.root.querySelector('.professional-alert__close');
    this.confirmBtn = this.root.querySelector('.professional-alert-btn');
    this.storageKey = 'professionalAlertClosed';

    this.focusableSelectors = [
      'button',
      '[href]',
      'input',
      'select',
      'textarea',
      '[tabindex]:not([tabindex="-1"])'
    ];

    this.init();
  }

  init() {
    if (sessionStorage.getItem(this.storageKey)) {
      this.root.classList.remove('professional-alert--active');
      return;
    }


    if (this.root.classList.contains('professional-alert--active')) {
      this.disableScroll();
    } else {
      this.open()
    }

    this.closeBtn?.addEventListener('click', () => this.close());
    this.confirmBtn?.addEventListener('click', () => this.close());

    this.modal.addEventListener('keydown', (e) => this.handleTab(e));
  }

  handleTab(e) {
    if (e.key !== 'Tab') return;

    const focusable = this.modal.querySelectorAll(this.focusableSelectors.join(','));
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  close() {
    this.root.classList.remove('professional-alert--active');
    this.enableScroll();

    sessionStorage.setItem(this.storageKey, 'true');
  }

  open() {
    this.root.classList.add('professional-alert--active');
    this.disableScroll();
    this.modal.focus();
  }

  disableScroll() {
    document.body.classList.add('modal-open');
  }

  enableScroll() {
    document.body.classList.remove('modal-open');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new ProfessionalAlert();
});